var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',[(_vm.visible)?_c('img',{staticClass:"asdsa",attrs:{"src":require("../static/fanhuidingbu.png")},on:{"click":_vm.backToTop}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }